"use strict";

$.widget("fotobook.multicolumnDropdown", $.ui.selectmenu, {
    "options" : {
        "classes" : {
            "ui-selectmenu-button" : "fotobook-multicolumn-dropdown-button",
            "ui-selectmenu-menu"   : "fotobook-multicolumn-dropdown-menu ui-widget-content",
        },
        "columns" : 4,
        "rows" : 2,
        "width" : false,
        "itemWidth" : 100,
        "position" : {
            "my": "left top",
            "at": "center center",
            "collision": "flip",
        },
        "jsp" : true,
        "emptyValue" : null,
        "selectedValue" : null,
        "optionTpl": [
            '<option value="{value}" {selected} data-html="{html}">{text}</option>',
        ].join(""),
    },

    /**
     * Сервисные функции для создания опций (для расширения виджета)
     */

    /**
     * Создаёт контент одного элемента
     */
    _createOptionContent: $.noop,

    /**
     * Возвращает массив элементов, из которых будут созданыопции
     * Один элемент - это объект:
     * {
     *    "value" : значение value для опции
     *    "text"  : текстовое содержимое опции
     *    "selected" : true/false - выбранная опция
     *    "item"  : сам элемент, который будет использовать в _createOptionContent
     * }
     */
    _getOptionsData: $.noop,

    _getCreateOptions: function(items){
        var widget = this,
            items = this._getOptionsData() || [];

        items = $.map(items, function(item, idx){
            return widget.options.optionTpl.supplant({
                "value" : item.value,
                "text"  : item.text,
                "selected" : item.selected ? "selected" : "",
                "html" : widget._renderOptionContent(item.item).escapeAttr(),
            });
        });

        if (this.options.emptyValue !== undefined){
            items.unshift(this.options.optionTpl.supplant({
                "value" : this.options.emptyValue,
                "text" : this.options.emptyValue,
                "selected" : "",
                "html" : "",
            }));
        }

        return items;
    },

    _createOptions: function(){
        this.element.html(this._getCreateOptions());
    },
    _create: function(){
        var widget = this;

        this._super();
        this._on(false, window, {
            "resize" : function(event){
                if (this.isOpen){
                    this._position();
                }
            },
        });
        this.menuWrap.addClass(this.options.classes["ui-selectmenu-menu"]);
        this.menu.wrap($('<div>', {
            "class" : "ui-selectmenu-wrapper jsp",
        }));
    },

    _renderButtonItem: function(item){
        return $(item.element.attr("data-html") || "<div>");
    },

    _liTemplate: [
        '<li>',
            '<div>',
                '{content}',
            '</div>',
        '</li>',
    ].join(""),
    _renderItem: function($ul, item){
        var li;

        li = this._liTemplate.supplant({
            "content" : item.element.attr("data-html"),
        });
        return $(li).appendTo($ul);
    },
    _refreshMenu: function(){
        var $jspItem = this.menuWrap.find(".jsp"),
            jsp = $jspItem.data("jsp");
        
        if (jsp){
            jsp.destroy();
        }
        this._super();
        this._resizeMenu();
    },
    _resizeMenu: function(){
        var $jspItem = this.menuWrap.find(".jsp"),
            jsp = $jspItem.data("jsp");
        
        if (jsp){
            jsp.reinitialise();
            return;
        }

        var $items = this.menu.find(".ui-menu-item").css({
                "width" : this.options.itemWidth,
                "height" : this.options.itemWidth,
            }),
            $firstItem = $items.first(),
            width = $firstItem.outerWidth(true),
            height = $firstItem.outerHeight(true);

        this.menuWrap.width(this.options.columns * width + (this.options.jsp ? 16 : 0));
        if (this.options.rows){
            this.menuWrap.height(this.options.rows * height);

            if (this.options.jsp){
                $jspItem.jScrollPane({
                    "showArrows": true,
                    "alwaysShowVScroll": true,
                    "doNotShowHScroll" : true,
                });
            }
        }
    },
});

